import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntSchadstoff: SelectDataObject[] = [
    { i: 0, t: '(unbekannt)' },
    { i: 1, t: 'Euro 1' },
    { i: 2, t: 'Euro 2' },
    { i: 3, t: 'Euro 3' },
    { i: 4, t: 'Euro 4' },
    { i: 5, t: 'Euro 5' },
    { i: 11, t: 'Euro 6' },
    { i: 14, t: 'Euro 6c' },
    { i: 15, t: 'Euro 6dTemp' },
    { i: 16, t: 'Euro 6d' },
    { i: 17, t: 'Euro 6e' },
    { i: 18, t: 'Euro 7' },
];
export default sIntSchadstoff;
